import { FC } from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';
import useClassNames from '@loomstateorg/shared-frontend/hooks/useClassNames';
import LoadingIcon from './loadingIcon';
import type { ButtonVariant } from './types';

export type FeedbackIconLayerProps = {
  loading?: boolean;
  variant?: ButtonVariant;
  feedbackPrimaryBg?: string;
  feedbackFallbackBg?: string;
};

const FeedbackIconLayer: FC<FeedbackIconLayerProps> = ({
  loading,
  variant = 'primary',
  feedbackPrimaryBg = 'bg-secondary-regular',
  feedbackFallbackBg = 'bg-white',
}) => {
  const variantBackgroundRef: { [key in ButtonVariant]?: string } = {
    primary: feedbackPrimaryBg,
    warning: 'bg-red-600',
  };

  const iconInWhite = variant == 'primary' || variant == 'warning';

  const layerClassName = useClassNames([
    'absolute top-0 left-0 grid h-full w-full items-center justify-center',
    variantBackgroundRef[variant] ?? feedbackFallbackBg,
  ]);

  const checkIconClassName = useClassNames(['w-20', { 'text-white': iconInWhite }]);
  const loadingIconClassName = iconInWhite ? 'fill-white' : 'fill-gray-700';

  const LoadingIconAny = LoadingIcon as any;
  const CheckIconAny = CheckIcon as any;

  return (
    <span className={layerClassName} data-testid="atom-button-feedback-layer" aria-hidden="true">
      {loading ? <LoadingIconAny className={loadingIconClassName} /> : <CheckIconAny className={checkIconClassName} />}
    </span>
  );
};

export default FeedbackIconLayer;
